import { ElxMessageBarType, IMessage } from '@elixir/components';

export const successMessage: IMessage = {
  message: 'Operation was executed successfully.',
  type: ElxMessageBarType.success,
};
